'use strict';

import moment from 'moment';

class BankTxBulkController {
    /* @ngInject */
    constructor(BankTxesService,
                $scope, $window, $mdDialog, $mdMenu) {
        Object.assign(this, {BankTxesService,
                             $scope, $window, $mdDialog, $mdMenu});
        this.btnEnabled = true;
    }

    save() {
        let lines = this.text.split(/\r\n|\r|\n/g).map(l => l.trim());
        console.debug(lines);
        let bankTxesData = [];
        let firstTxIndex = lines.findIndex(l => {
            let m = moment(l, 'DD/MM/YYYY');
            return m.isValid();
        });
        let validLines = lines.slice(firstTxIndex);
        let promises = [],
            successes = [];
        this.showSpin = true;
        while (validLines.length) {
            let currLines = validLines.splice(0, 5);
            console.debug(currLines);
            let date = moment(currLines[0], 'DD/MM/YYYY');
            if (!date.isValid()) {
                console.debug('date not valid ', currLines);
                continue;
            }
            let desc = currLines[1];
            let isCredit = desc.match(/^(DEPOSITO EN EFECTIVO|CACA)$/);
            if (!isCredit) {
                console.debug('not a credit ', currLines);
                continue;
            }
            let externalId = currLines[2];
            if (!externalId) {
                console.debug('externalId not valid ', currLines);
                continue;
            }

            let amount = parseFloat(currLines[3] || currLines[4]);
            if (isNaN(amount)) {
                console.debug('amount not valid ', currLines);
                continue;
            }
            promises.push(
                this.BankTxesService.fromStatement({
                    date: date.toDate(),
                    comments: desc,
                    externalId: externalId,
                    amount: amount * 100
                }).then(bankTx => {
                    successes.push(bankTx);
                }, err => {
                    console.error(err);
                })
            );
        }
        Promise.all(promises).then(() => {
            // TODO: success message
            console.debug('SUCCESS');
            let text = `Cantidad de Transacciones agregadas: \
${successes.length}.`;
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Transacciones procesadas')
                    .textContent(text)
                    .ok('Aceptar')

            );
            this.showSpin = false;
        }, err => {
            console.error(err);
            // TODO: display error
            this.showSpin = false;
        });
    }
}

export default BankTxBulkController;
